import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { NewFeatureComponent } from './new-feature';

@NgModule({
	declarations: [NewFeatureComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		GenericDirectivesModule
	],
	exports: [NewFeatureComponent]
})
export class NewFeatureHighlightsModule { }
